const ruleNameMap = {
	PM: 'Platform Mismatch',
	IQ: 'IP Quality',
	OD: 'OS Distribution',
};

export default ruleNameMap;
